export default __webpack_public_path__ + "static/media/forgotPassword.6dc0f0a8.svg";